import { indexBy } from "ramda";
import { NavBarLeft, NavBarTop } from "../../components-common/layout";
import { WorkspaceLayout } from "../../components-system/layouts/WorkspaceLayout";
import { menuCourse } from "./menu.course";
import { sectionHeader } from "./menu.top";
import { RoleSwitcher } from "../../components-common/layout/RoleSwitcher";
import { Component } from "react";
import { Outlet } from "react-router-dom";

export const sections = [
  sectionHeader,
  {
    id: "content",
    components: [
      {
        Component: Outlet,
        id:"workspace_layout_content",
        props: {
        },
        children: [
        ],
      }
    ]
  },
  {
    id: "sidebar",
    components: [
      {
        Component: NavBarLeft,
        props: {
          items: [],
          children: [
            RoleSwitcher
          ]
        },
        children: [
          RoleSwitcher
        ],
        // actions: [
        //   {
        //     operation: "replace",
        //     prop: "items",
        //     value: [
        //       {
        //         id: "menu.course.dashboard",
        //         to: "/courses/:courseId/dashboard",
        //         label: "Dashboard",
        //         icon: "dashboard",
        //       },
        //       {
        //         id: "menu.course.students",
        //         to: "/courses/:courseId/students",
        //         label: "Students",
        //         icon: "student",
        //       },
        //       {
        //         id: "menu.course.lecturers",
        //         to: "/courses/:courseId/lecturers",
        //         label: "Lecturers",
        //         icon: "lecturer",
        //       },
        //       {
        //         id: "menu.course.resources",
        //         to: "/courses/:courseId/resources",
        //         label: "Resources",
        //         icon: "resources",
        //       },
        //       {
        //         id: "menu.course.assignments",
        //         to: "/courses/:courseId/assignments",
        //         label: "Assignments",
        //         icon: "assignments",
        //       },
        //       // {
        //       //   to: "/courses/:id/groups",
        //       //   label: "Groups",
        //       //   icon: "Groups",
        //       // }
        //     ],
        //     condition: {
        //       prop: "role",
        //       value: ["STUDENT","LECTURER","STUDY_DIRECTOR"]
        //     },
        //   }
        // ]
      }
    ]
  }

];

export const layoutWorkspace = {
  id: "layout_workspace",
  cat: "layout",
  type: "workspace",
  Component: WorkspaceLayout,
  props: {
    sections:  indexBy((x: any) => x.id,sections as any),
  },
  menuProfile: {
    children: [
      {
        id: "admin_11",
        children: "Profile4434",
        to: "/users/profile",
      },
      {
        id: "admin_13",
        children: "Settings",
        to: "/users/settings",
      },
      {
        id: "admin_12",
        children: "Management",
        to: "/management",
      },
      {
        id: "admin_12",
        children: "Lecturers",
        to: "/lecturers",
      },
      {
        id: "admin_14",
        children: "Students",
        to: "/students",
      },
    ],
  } as any
} as any
